const DEFAULT_PREVIEW_VIDEO_VOLUME = 0.5;

const ANT_IMAGE_PREVIEW_VIDEO_SELECTOR = '.ant-image-preview-root video';
const ANT_IMAGE_PREVIEW_IFRAME_SELECTOR = '.ant-image-preview-root iframe';

type PreviewCloseOptionsType = {
    setOpen: (open: boolean) => void;
    stop: () => void;
};

export function applyPreviewVideoVisibleChange(visible: boolean, options: PreviewCloseOptionsType): void {
    if (!visible) {
        options.stop();
    }

    options.setOpen(visible);
}

export type PreviewVideoHandleType = {
    currentTime: number;
    pause: () => void;
    volume: number;
};

function isPreviewVideoHandle(value: unknown): value is PreviewVideoHandleType {
    if (typeof value !== 'object' || value === null) {
        return false;
    }

    return (
        Reflect.get(value, 'tagName') === 'VIDEO' &&
        typeof Reflect.get(value, 'pause') === 'function' &&
        typeof Reflect.get(value, 'currentTime') === 'number' &&
        typeof Reflect.get(value, 'volume') === 'number'
    );
}

export function asPreviewVideoHandle(element: unknown): PreviewVideoHandleType | null {
    return isPreviewVideoHandle(element) ? element : null;
}

function resetVideoPlayback(video: PreviewVideoHandleType): null {
    video.pause();
    Reflect.set(video, 'currentTime', 0);

    return null;
}

export function applyPreviewVolume(video: PreviewVideoHandleType): null {
    Reflect.set(video, 'volume', DEFAULT_PREVIEW_VIDEO_VOLUME);

    return null;
}

function getAntImagePreviewVideos(): Array<PreviewVideoHandleType> {
    return [...globalThis.document.querySelectorAll(ANT_IMAGE_PREVIEW_VIDEO_SELECTOR)].reduce<
        Array<PreviewVideoHandleType>
    >((accumulator, element) => {
        const video = asPreviewVideoHandle(element);

        return video ? [...accumulator, video] : accumulator;
    }, []);
}

function stopDomPreviewVideos(): null {
    getAntImagePreviewVideos().map(resetVideoPlayback);

    return null;
}

function stopDomPreviewIframes(): null {
    [...globalThis.document.querySelectorAll(ANT_IMAGE_PREVIEW_IFRAME_SELECTOR)].forEach((element) => {
        if (element instanceof HTMLIFrameElement) {
            Reflect.set(element, 'src', 'about:blank');
        }
    });

    return null;
}

export function stopPreviewVideos(activeVideo: PreviewVideoHandleType | null): void {
    if (activeVideo) {
        resetVideoPlayback(activeVideo);
    }

    stopDomPreviewVideos();
    stopDomPreviewIframes();
}
